import { actionTypes } from '../actions/actions';

const INITIAL_STATE = {
  canRequest: false,
  isChecking: false,
  error: null,
};

const ableToRequestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.ableToRequest: {
      return {
        isChecking: true,
        canRequest: false,
        error: null,
      };
    }
    case actionTypes.isAbleToRequest: {
      return {
        isChecking: false,
        canRequest: true,
        error: null,
      };
    }
    case actionTypes.notAbleToRequest: {
      return {
        isChecking: false,
        canRequest: false,
        error: action.payload.error,
      };
    }
    case actionTypes.clearAbleToRequest: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};

export default ableToRequestReducer;
